import { useQuery } from "@tanstack/solid-query"
import { createFileRoute } from "@tanstack/solid-router"
import { For, Show } from "solid-js"
import { Button } from "~/components/ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "~/components/ui/card"
import { Col, Grid } from "~/components/ui/grid"
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "~/components/ui/select"
import { orpc } from "~/lib/orpc"

export const Route = createFileRoute("/_authenticated/store")({
  // beforeLoad: ({ context }) => context.queryClient.prefetchQuery(orpc.tebex.categories.list.queryOptions()),
  // loader: async ({ context }) => {
  //   const categories = await context.queryClient.ensureQueryData(orpc.tebex.categories.list.queryOptions())

  //   context.queryClient.prefetchQuery(
  //     orpc.tebex.categories.products.queryOptions({ input: { category: categories[0].id } })
  //   )
  // },
  beforeLoad: ({ context }) => context.queryClient.prefetchQuery(orpc.tebex.categories.products.queryOptions()),
  component: RouteComponent
})

function RouteComponent() {
  // const categories = useQuery(() => orpc.tebex.categories.list.queryOptions())

  // const [category, setCategory] = createSignal<
  //   | {
  //       value: string
  //       label: string
  //       disabled: boolean
  //     }
  //   | undefined
  // >(categories.data && { value: String(categories.data[0].id), label: categories.data[0].name, disabled: false })

  const packages = useQuery(() => orpc.tebex.categories.products.queryOptions())

  return (
    <div class="p-6">
      <div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 class="font-semibold text-2xl">Shop</h2>
          <p class="text-muted-foreground text-sm">Browse products by category</p>
        </div>

        {/*<div class="w-full max-w-xs">
          <Show when={categories.data}>
            <Select
              value={category()}
              onChange={setCategory}
              options={categories.data?.map((cat) => ({ value: String(cat.id), label: cat.name, disabled: false }))!}
              optionValue="value"
              optionTextValue="label"
              optionDisabled="disabled"
              placeholder="Select a category"
              itemComponent={(props) => <SelectItem item={props.item}>{props.item.rawValue.label}</SelectItem>}
              disallowEmptySelection
              multiple={false}
            >
              <SelectTrigger aria-label="Category" class="w-[180px]">
                <SelectValue<{
                  value: string
                  label: string
                  disabled: boolean
                }>>
                  {(state) => state.selectedOption().label}
                </SelectValue>
              </SelectTrigger>
              <SelectContent />
            </Select>
          </Show>
        </div>*/}
      </div>

      <Show when={packages.data}>
        <Grid cols={1} colsSm={2} colsMd={3} colsLg={4} class="gap-4">
          <For each={packages.data}>
            {(product) => (
              <Col>
                <Card class="flex h-full flex-col">
                  <CardHeader>
                    <CardTitle>{product.name}</CardTitle>
                    {/*<CardDescription>{product}</CardDescription>*/}
                  </CardHeader>

                  <CardContent class="flex-1">
                    <div class="mb-4 text-muted-foreground text-sm" innerHTML={product.description}></div>
                    <div class="flex w-full items-center justify-center rounded-md bg-muted/30 text-muted-foreground text-sm">
                      <Show when={product.image} fallback={<div>No image available.</div>}>
                        <img src={product.image!} alt={product.name} />
                      </Show>
                    </div>
                  </CardContent>

                  <CardFooter class="justify-between">
                    <div>
                      <div class="text-muted-foreground text-sm">Price</div>
                      <div class="font-semibold">${product.total_price.toFixed(2)}</div>
                    </div>

                    <Button variant="default" size="sm">
                      Buy
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
            )}
          </For>
        </Grid>
      </Show>
    </div>
  )
}
